module.exports = __webpack_public_path__ + "static/media/spiritWeb.0d72cd37.jpg";